module.exports = __webpack_public_path__ + "img/nora-logo_tmp.2dc191.svg";